export const AGORA = 'AGORA';
export const VOXEET = 'VOXEET';
export const ZOOM = 'ZOOM'; //Not implemented yet
